import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';



export const PdfGeneratorService = () => {
    const loadRobotoFont = (doc: jsPDF) => {
        doc.addFont('/fonts/Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.addFont('/fonts/Roboto-Medium.ttf', 'Roboto', 'semibold');
        doc.addFont('/fonts/Roboto-Bold.ttf', 'Roboto', 'bold');
        doc.setFont('Roboto', 'semibold');
    };

    const formatDateToSpanish = (isoDateTime: string): string => {
        const months = [
            'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
            'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ];
        const date = new Date(isoDateTime);
        return `${date.getDate().toString().padStart(2, '0')} de ${months[date.getUTCMonth()]} de ${date.getUTCFullYear()}`;
    };

    const formatUserName = (completeName: string): string => {
        console.log({ completeName })
         return completeName.replaceAll('null', '');
    }


    const generateCertificate = async (data: any) => {
        const doc = new jsPDF({ orientation: 'landscape' });
        loadRobotoFont(doc);

        const sign1 = new Image();
        const sign2 = new Image();

        sign1.src = '/images/sign_1.png';
        sign2.src = '/images/sign_2.png';

        const pageWidth = doc.internal.pageSize.getWidth();
        const centerX = pageWidth / 2;

        const pageTableWidht = doc.internal.pageSize.getWidth() - 20;

        const image = '/LOGO_ASG.png';
        doc.addImage(image, 'PNG', centerX - 22.5, 10, 45, 26);

        // Título "CERTIFICADO"
        doc.setFontSize(29);
        doc.setFont('Roboto', 'bold');
        doc.text('CERTIFICADO', centerX, 50, { align: 'center' });

        // Texto de presentación
        doc.setFontSize(11);
        doc.setFont('Roboto', 'normal');
        doc.text('Confiere el presente certificado de asistencia al Sr(a)(ita):', centerX, 60, { align: 'center' });

        doc.setFont('Roboto', 'bold');
        autoTable(doc, {
            body: [[formatUserName(data.complete_name)]],
            startY: 65,
            margin: { left: 10, right: 10 },
            tableWidth: pageTableWidht,
            styles: { fontSize: 23, cellPadding: 2, lineWidth: 0, halign: 'center', valign: 'middle', font: 'Roboto', fontStyle: 'bold' },
            columnStyles: { 0: { halign: 'center', fontSize: 23, valign: 'middle', textColor: [0, 0, 0] } },
            theme: 'grid'
        });

        doc.setFont('Roboto', 'normal');
        doc.text('En mérito a su participación del curso:', centerX, (doc as any).lastAutoTable.finalY + 8, { align: 'center' });

        // Nombre del curso
        doc.setFont('Roboto', 'bold');
        doc.setFontSize(25);
        autoTable(doc, {
            body: [[(data.name as string).toUpperCase()]],
            startY: (doc as any).lastAutoTable.finalY + 13,
            margin: { left: 10, right: 10 },
            tableWidth: pageTableWidht,
            styles: { fontSize: 23, cellPadding: 2, lineWidth: 0, halign: 'center', valign: 'middle', font: 'Roboto', fontStyle: 'bold' },
            columnStyles: { 0: { halign: 'center', fontSize: 23, valign: 'middle', textColor: [0, 0, 0] } },
            theme: 'grid'
        });

        const tableEndY = (doc as any).lastAutoTable.finalY;

        doc.setFontSize(11);
        doc.setFont('Roboto', 'normal');
        doc.text('Con un total de', centerX, tableEndY + 8, { align: 'center' });

        doc.setFontSize(11);
        doc.setFont('Roboto', 'bold');
        autoTable(doc, {
            body: [['1 hora']],
            startY: (doc as any).lastAutoTable.finalY + 10,
            margin: { left: 10, right: 10 },
            tableWidth: pageTableWidht,
            styles: { fontSize: 12, cellPadding: 2, lineWidth: 0, halign: 'center', valign: 'middle', font: 'Roboto', fontStyle: 'bold' },
            columnStyles: { 0: { halign: 'center', fontSize: 12, valign: 'middle', textColor: [0, 0, 0] } },
            theme: 'grid'
        });

        autoTable(doc, {
            body: [['Fecha de entrega']],
            startY: (doc as any).lastAutoTable.finalY + 8,
            margin: { left: 10, right: 10 },
            tableWidth: pageTableWidht,
            styles: { fontSize: 10, cellPadding: 2, lineWidth: 0, halign: 'center', valign: 'middle', font: 'Roboto', fontStyle: 'bold' },
            columnStyles: { 0: { halign: 'center', fontSize: 10, valign: 'middle', textColor: [0, 0, 0] } },
            theme: 'grid'
        });

        doc.setFont('Roboto', 'normal');
        doc.text(formatDateToSpanish(data.date), centerX, (doc as any).lastAutoTable.finalY + 5, { align: 'center' });

        const yPosFirma = (doc as any).lastAutoTable.finalY + 30;
        doc.line(115, yPosFirma, 45, yPosFirma);
        doc.line(centerX + 105, yPosFirma, centerX + 35, yPosFirma);

        doc.addImage(sign1, 'JPEG', 58, yPosFirma - 20, 45, 35);
        doc.addImage(sign2, 'JPEG', centerX + 48, yPosFirma - 20, 50, 35);

        doc.setFontSize(10);
        doc.setFont('Roboto', 'bold');
        doc.text('Antonio del Campo Flores', 60, yPosFirma + 5);

        doc.setFont('Roboto', 'normal');
        doc.text('Gerente General', 66, yPosFirma + 10);
        doc.text('Aviation Security Group S.A.C.', 57, yPosFirma + 15);

        doc.setFont('Roboto', 'bold');
        doc.text('Guillermo Ccoiso Velez de Villa', centerX + 47, yPosFirma + 5);

        doc.setFont('Roboto', 'normal');
        doc.text('Coordinador SIG', centerX + 58, yPosFirma + 10);
        doc.text('Aviation Security Group S.A.C.', centerX + 49, yPosFirma + 15);

        doc.setFont('Roboto', 'bold');
        doc.text('Validez: 365 días desde su fecha de expedición.', 12, 200)
        doc.text(`Fecha de expedición ${formatDateToSpanish(data.date)}`, 217, 200)

        doc.save(`Certificado - ${data.name}.pdf`);
    };

    const generateCertificateBase64 = async (data: any) => {
        const doc = new jsPDF({ orientation: 'landscape' });
        loadRobotoFont(doc);

        const sign1 = new Image();
        const sign2 = new Image();

        sign1.src = '/images/sign_1.png';
        sign2.src = '/images/sign_2.png';

        const pageWidth = doc.internal.pageSize.getWidth();
        const centerX = pageWidth / 2;

        const pageTableWidht = doc.internal.pageSize.getWidth() - 20;

        const image = '/LOGO_ASG.png';
        doc.addImage(image, 'PNG', centerX - 22.5, 10, 45, 26);

        // Título "CERTIFICADO"
        doc.setFontSize(29);
        doc.setFont('Roboto', 'bold');
        doc.text('CERTIFICADO', centerX, 50, { align: 'center' });

        // Texto de presentación
        doc.setFontSize(11);
        doc.setFont('Roboto', 'normal');
        doc.text('Confiere el presente certificado de asistencia al Sr(a)(ita):', centerX, 60, { align: 'center' });

        doc.setFont('Roboto', 'bold');
        autoTable(doc, {
            body: [[formatUserName(data.complete_name)]],
            startY: 65,
            margin: { left: 10, right: 10 },
            tableWidth: pageTableWidht,
            styles: { fontSize: 23, cellPadding: 2, lineWidth: 0, halign: 'center', valign: 'middle', font: 'Roboto', fontStyle: 'bold' },
            columnStyles: { 0: { halign: 'center', fontSize: 23, valign: 'middle', textColor: [0, 0, 0] } },
            theme: 'grid'
        });

        doc.setFont('Roboto', 'normal');
        doc.text('En mérito a su participación del curso:', centerX, (doc as any).lastAutoTable.finalY + 8, { align: 'center' });

        // Nombre del curso
        doc.setFont('Roboto', 'bold');
        doc.setFontSize(25);
        autoTable(doc, {
            body: [[(data.name as string).toUpperCase()]],
            startY: (doc as any).lastAutoTable.finalY + 13,
            margin: { left: 10, right: 10 },
            tableWidth: pageTableWidht,
            styles: { fontSize: 23, cellPadding: 2, lineWidth: 0, halign: 'center', valign: 'middle', font: 'Roboto', fontStyle: 'bold' },
            columnStyles: { 0: { halign: 'center', fontSize: 23, valign: 'middle', textColor: [0, 0, 0] } },
            theme: 'grid'
        });

        const tableEndY = (doc as any).lastAutoTable.finalY;

        doc.setFontSize(11);
        doc.setFont('Roboto', 'normal');
        doc.text('Con un total de', centerX, tableEndY + 8, { align: 'center' });

        // Duración
        doc.setFontSize(11);
        doc.setFont('Roboto', 'bold');
        autoTable(doc, {
            body: [['1 hora']],
            startY: (doc as any).lastAutoTable.finalY + 10,
            margin: { left: 10, right: 10 },
            tableWidth: pageTableWidht,
            styles: { fontSize: 12, cellPadding: 2, lineWidth: 0, halign: 'center', valign: 'middle', font: 'Roboto', fontStyle: 'bold' },
            columnStyles: { 0: { halign: 'center', fontSize: 12, valign: 'middle', textColor: [0, 0, 0] } },
            theme: 'grid'
        });
        // Fecha de entrega
        autoTable(doc, {
            body: [['Fecha de entrega']],
            startY: (doc as any).lastAutoTable.finalY + 8,
            margin: { left: 10, right: 10 },
            tableWidth: pageTableWidht,
            styles: { fontSize: 10, cellPadding: 2, lineWidth: 0, halign: 'center', valign: 'middle', font: 'Roboto', fontStyle: 'bold' },
            columnStyles: { 0: { halign: 'center', fontSize: 10, valign: 'middle', textColor: [0, 0, 0] } },
            theme: 'grid'
        });

        doc.setFont('Roboto', 'normal');
        doc.text(formatDateToSpanish(data.date), centerX, (doc as any).lastAutoTable.finalY + 5, { align: 'center' });

        const yPosFirma = (doc as any).lastAutoTable.finalY + 30;
        doc.line(115, yPosFirma, 45, yPosFirma);
        doc.line(centerX + 105, yPosFirma, centerX + 35, yPosFirma);

        doc.addImage(sign1, 'JPEG', 58, yPosFirma - 20, 45, 35);
        doc.addImage(sign2, 'JPEG', centerX + 48, yPosFirma - 20, 50, 35);

        doc.setFontSize(10);
        doc.setFont('Roboto', 'bold');
        doc.text('Antonio del Campo Flores', 60, yPosFirma + 5);

        doc.setFont('Roboto', 'normal');
        doc.text('Gerente General', 66, yPosFirma + 10);
        doc.text('Aviation Security Group S.A.C.', 57, yPosFirma + 15);

        doc.setFont('Roboto', 'bold');
        doc.text('Guillermo Ccoiso Velez de Villa', centerX + 47, yPosFirma + 5);

        doc.setFont('Roboto', 'normal');
        doc.text('Coordinador SIG', centerX + 58, yPosFirma + 10);
        doc.text('Aviation Security Group S.A.C.', centerX + 49, yPosFirma + 15);

        doc.setFont('Roboto', 'bold');
        doc.text('Validez: 365 días desde su fecha de expedición.', 12, 200)
        doc.text(`Fecha de expedición ${formatDateToSpanish(data.date)}`, 217, 200)

        const base64String = doc.output("datauristring").split(",")[1];

        return base64String;
    };

    const generateRegisterCertificateBase64 = async (data: any) => {
        const doc = new jsPDF({ orientation: 'landscape' });
        loadRobotoFont(doc);

        const sign1 = new Image();
        const sign2 = new Image();

        sign1.src = '/images/sign_1.png';
        sign2.src = '/images/sign_2.png';

        const pageWidth = doc.internal.pageSize.getWidth();
        const centerX = pageWidth / 2;

        const pageTableWidht = doc.internal.pageSize.getWidth() - 20;

        const image = '/LOGO_ASG.png';
        doc.addImage(image, 'PNG', centerX - 22.5, 10, 45, 26);

        // Título "CERTIFICADO"
        doc.setFontSize(29);
        doc.setFont('Roboto', 'bold');
        doc.text('CERTIFICADO', centerX, 50, { align: 'center' });

        // Texto de presentación
        doc.setFontSize(11);
        doc.setFont('Roboto', 'normal');
        doc.text('Confiere el presente certificado de registro al Sr(a)(ita):', centerX, 60, { align: 'center' });

        doc.setFont('Roboto', 'bold');
        autoTable(doc, {
            body: [[formatUserName(data.complete_name)]],
            startY: 65,
            margin: { left: 10, right: 10 },
            tableWidth: pageTableWidht,
            styles: { fontSize: 23, cellPadding: 2, lineWidth: 0, halign: 'center', valign: 'middle', font: 'Roboto', fontStyle: 'bold' },
            columnStyles: { 0: { halign: 'center', fontSize: 23, valign: 'middle', textColor: [0, 0, 0] } },
            theme: 'grid'
        });
        

        // Fecha de entrega
        autoTable(doc, {
            body: [['Fecha de registro']],
            startY: (doc as any).lastAutoTable.finalY + 8,
            margin: { left: 10, right: 10 },
            tableWidth: pageTableWidht,
            styles: { fontSize: 10, cellPadding: 2, lineWidth: 0, halign: 'center', valign: 'middle', font: 'Roboto', fontStyle: 'bold' },
            columnStyles: { 0: { halign: 'center', fontSize: 10, valign: 'middle', textColor: [0, 0, 0] } },
            theme: 'grid'
        });

        doc.setFont('Roboto', 'normal');
        doc.text(formatDateToSpanish(data.date), centerX, (doc as any).lastAutoTable.finalY + 6, { align: 'center' });

        const yPosFirma = (doc as any).lastAutoTable.finalY + 30;
        doc.line(115, yPosFirma, 45, yPosFirma);
        doc.line(centerX + 105, yPosFirma, centerX + 35, yPosFirma);

        doc.addImage(sign1, 'JPEG', 58, yPosFirma - 20, 45, 35);
        doc.addImage(sign2, 'JPEG', centerX + 48, yPosFirma - 20, 50, 35);

        doc.setFontSize(10);
        doc.setFont('Roboto', 'bold');
        doc.text('Antonio del Campo Flores', 60, yPosFirma + 5);

        doc.setFont('Roboto', 'normal');
        doc.text('Gerente General', 66, yPosFirma + 10);
        doc.text('Aviation Security Group S.A.C.', 57, yPosFirma + 15);

        doc.setFont('Roboto', 'bold');
        doc.text('Guillermo Ccoiso Velez de Villa', centerX + 47, yPosFirma + 5);

        doc.setFont('Roboto', 'normal');
        doc.text('Coordinador SIG', centerX + 58, yPosFirma + 10);
        doc.text('Aviation Security Group S.A.C.', centerX + 49, yPosFirma + 15);

        const base64String = doc.output("datauristring").split(",")[1];

        return base64String;
    };

    const generatePoliticCertificate = async (data: any) => {
        const doc = new jsPDF({ orientation: 'landscape' });
        loadRobotoFont(doc);

        const sign1 = new Image();
        const sign2 = new Image();

        sign1.src = '/images/sign_1.png';
        sign2.src = '/images/sign_2.png';

        const pageWidth = doc.internal.pageSize.getWidth();
        const centerX = pageWidth / 2;

        const pageTableWidht = doc.internal.pageSize.getWidth() - 20;
        const initialPositionY = 45

        const image = '/LOGO_ASG.png';
        doc.addImage(image, 'PNG', centerX - 22.5, initialPositionY, 45, 26);

        // Título "CERTIFICADO"
        doc.setFontSize(29);
        doc.setFont('Roboto', 'bold');
        doc.text('CONSTANCIA', centerX, initialPositionY + 40, { align: 'center' });

        // Texto de presentación
        doc.setFontSize(11);
        doc.setFont('Roboto', 'normal');
        doc.text('Confiere la presente constancia de haber leído y aceptado la política:', centerX, initialPositionY + 50, { align: 'center' });

        // Nombre del curso
        doc.setFont('Roboto', 'bold');
        doc.setFontSize(25);
        autoTable(doc, {
            body: [[data.politic_name]],
            startY: initialPositionY + 55,
            margin: { left: 10, right: 10 },
            tableWidth: pageTableWidht,
            styles: { fontSize: 23, cellPadding: 2, lineWidth: 0, halign: 'center', valign: 'middle', font: 'Roboto', fontStyle: 'bold' },
            columnStyles: { 0: { halign: 'center', fontSize: 23, valign: 'middle', textColor: [0, 0, 0] } },
            theme: 'grid'
        });

        const yPosFirma = (doc as any).lastAutoTable.finalY + 30;
        doc.line(115, yPosFirma, 45, yPosFirma);
        doc.line(centerX + 105, yPosFirma, centerX + 35, yPosFirma);

        doc.addImage(sign1, 'JPEG', 58, yPosFirma - 20, 45, 35);
        doc.addImage(sign2, 'JPEG', centerX + 48, yPosFirma - 20, 50, 35);

        doc.setFontSize(10);
        doc.setFont('Roboto', 'bold');
        doc.text('Antonio del Campo Flores', 60, yPosFirma + 5);

        doc.setFont('Roboto', 'normal');
        doc.text('Gerente General', 66, yPosFirma + 10);
        doc.text('Aviation Security Group S.A.C.', 57, yPosFirma + 15);

        doc.setFont('Roboto', 'bold');
        doc.text('Guillermo Ccoiso Velez de Villa', centerX + 47, yPosFirma + 5);

        doc.setFont('Roboto', 'normal');
        doc.text('Coordinador SIG', centerX + 58, yPosFirma + 10);
        doc.text('Aviation Security Group S.A.C.', centerX + 49, yPosFirma + 15);

        doc.save("Constancia - " + data.politic_name + ".pdf");
    };

    return { generateCertificate, generatePoliticCertificate, generateCertificateBase64, generateRegisterCertificateBase64 };
};
